<template>
  <layout-with-back-btn title="Detail Fulfillment">
    <div
      v-if="loading"
      class="mx-[20px] flex items-center justify-center gap-[10px]"
    >
      <b-spinner
        v-if="loading"
        variant="primary"
      />
      <p class="mb-0">
        Memuat data...
      </p>
    </div>
    <div
      v-else-if="isError"
      class="mx-[20px] flex items-center justify-center gap-[10px]"
    >
      <p class="mb-0">
        Gagal mengambil data, silahkan coba lagi.
      </p>
    </div>
    <div
      v-else
      class="text-black mt-[20px]"
    >
      <div class="mx-[20px]">
        <div class="fulfillment-detail-card">
          <p class="fulfillment-detail-card_title">
            Alamat
          </p>
          <div class="flex items-start gap-[10px]">
            <span>:</span>
            <div>
              <p>
                {{ detail.warehouse_name }}
              </p>
            </div>
          </div>
        </div>
        <div class="fulfillment-detail-card">
          <p class="fulfillment-detail-card_title">
            Tanggal
          </p>
          <div class="flex items-start gap-[10px]">
            <span>:</span>
            <div>
              <p>
                {{ DAY_MONTH_YEAR(detail.created_at) }}
              </p>
            </div>
          </div>
        </div>
        <div class="fulfillment-detail-card">
          <p class="fulfillment-detail-card_title">
            Status
          </p>
          <div class="flex items-start gap-[10px]">
            <span>:</span>
            <div>
              <p>
                {{ detail.order_status }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2 border rounded-[16px]">
        <div class="d-flex justify-between align-items-center p-2">
          <div class="text-black font-bold">
            Packing List
          </div>
        </div>
        <BTable
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          show-empty
          :items="products"
          :fields="fieldsDetailProduct"
        >
          <template #cell(product_name)="productData">
            <div class="d-flex items-start space-x-2">
              <b-img
                src="https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg"
                fluid
                class="image-product size-[52px]"
              />
              <div class="min-h-[52px] flex flex-col justify-center">
                <div class="text-black font-bold">
                  {{ productData.value }}
                </div>
                <p
                  v-if="productData.item.product_variant_name"
                  class="mb-0"
                >
                  {{ productData.item.product_variant_name }}</p>
                <div
                  v-else-if="productData.item.is_bundling"
                  class="relative"
                >
                  <!-- Hidden checkbox untuk kontrol toggle -->
                  <input
                    :id="`bundling-toggle-${productData.index}`"
                    type="checkbox"
                    class="hidden peer"
                  >

                  <!-- Button bundling sebagai label -->
                  <label
                    :for="`bundling-toggle-${productData.index}`"
                    class="flex items-center gap-[4px] py-[4px] px-[8px] rounded-[12px] !bg-[#08A0F7] text-white font-[500] cursor-pointer mt-[5px] w-[7rem] transition-all duration-200 hover:bg-[#0691d6] peer-checked:bg-[#0691d6]"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/gift.svg"
                      alt="bundling"
                      width="16"
                    >
                    <span>Bundling</span>
                  </label>

                  <!-- List bundling yang akan muncul/hilang -->
                  <div class="hidden peer-checked:block peer-checked:visible mt-[8px] animate-[fadeIn_0.2s_ease-in-out]">
                    <div class="bg-gray-50 rounded-[8px] p-[8px] border-l-4 border-[#08A0F7]">
                      <h4 class="text-sm font-semibold text-gray-700">
                        Isi Bundling:
                      </h4>
                      <div class="bg-white rounded-[8px] overflow-hidden shadow-sm">
                        <BTable
                          :items="productData.item.bundle_component || []"
                          :fields="fieldsDetailBundling"
                          class="!rounded-[8px] mb-0"
                          small
                        >
                          <template #cell(product_name)="bundleData">
                            <div>
                              <p class="mb-0 font-semibold text-sm">
                                {{ bundleData.value }}
                              </p>
                              <p
                                v-if="bundleData.item.product_variant_name"
                                class="mb-0 text-xs text-gray-500"
                              >
                                {{ bundleData.item.product_variant_name }}
                              </p>
                              <p
                                v-else
                                class="mb-0 text-xs text-gray-400"
                              >
                                Tidak ada varian
                              </p>
                            </div>
                          </template>
                          <template #cell(qty)="bundleData">
                            <span class="text-sm font-semibold text-[#08A0F7]">
                              {{ bundleData.value || 1 }} X
                            </span>
                          </template>
                        </BTable>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class=""
                >
                  -
                </div>
              </div>
            </div>
          </template>
          <template #cell(qty)="productData">
            <p class="mb-0 h-[52px] flex items-center">
              {{ productData.value }}X
            </p>
          </template>
          <template v-slot:custom-foot>
            <b-tr class="">
              <b-td class="font-bold pt-1 pb-0">
                Total
              </b-td>
              <b-td class="text-black pt-1 pb-0">
                {{ totalProduct }}X
              </b-td>
            </b-tr>
          </template>
        </BTable>
      </div>
    </div>
  </layout-with-back-btn>
</template>

<script>
import LayoutWithBackBtn from '@/views/pages/kompack/LayoutWithBackBtn.vue'
import { DAY_MONTH_YEAR, TIME } from '@/libs/filterDate'
import imageNull from '@/assets/images/avatars/image-null.png'
import { fieldsDetailProduct, fieldsDetailBundling } from './config'

/**
 * Component untuk menampilkan detail fulfillment komship
 * @component FulfillmentKomshipDetail
 */
export default {
  components: {
    LayoutWithBackBtn,
  },
  data() {
    return {
      loading: true,
      isError: false,
      detail: {},
      products: [],
      totalProduct: 0,
      data: {
        address_name: 'Gudang Condro Bocil',
        address_detail: 'rumah bocil condroo',
        district: 'BOBOTSARI',
        pic_name: 'Condro bocil',
        pic_phone: '87846700752',
        pickup_date: '2025-07-28',
        pickup_time: '21:00:00',
        vehicle: 'MOTOR',
        data_order: [
          {
            product_id: 2400,
            product_name: 'Gelang Karet',
            is_variant: 1,
            total: 0,
            image_path: '',
            image_path_base64: '',
            variant: [
              {
                product_variant_name: 'Biru',
                total: 1,
                product_variant_id: 12321,
              },
            ],
          },
        ],
        total_qty: 1,
        total_order: 1,
      },
      imageNull,
      fieldsDetailProduct,
      fieldsDetailBundling,
    }
  },
  mounted() {
    this.fnFetchData()
  },
  methods: {
    DAY_MONTH_YEAR,
    TIME,
    /**
     * Set gambar default saat gambar produk gagal dimuat
     * @param {Event} event - Event error dari image
     */
    setImageDefault(event) {
      const { target } = event
      target.src = imageNull
    },
    async fnFetchData() {
      if (!this.$route.params.id) {
        this.$toast_error({
          message: 'ID tidak ditemukan, silahkan coba lagi.',
        })
        return
      }
      try {
        const { data } = await this.$http_new.get(`/komship/api/v1/admin/orders/kompack/request/${this.$route.params.id}/details`)

        const [detail] = data.data

        this.detail = detail

        this.data = data.data
        const products = data.data.flatMap(item => item.products)
        this.totalProduct = products.reduce((acc, item) => acc + item.qty, 0)
        this.products = products
      } catch (error) {
        this.$toast_error({
          message: 'Gagal mengambil data, silahkan coba lagi.',
        })
        this.isError = true
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.fulfillment-detail-card {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 12px;
    flex-wrap: wrap;

    p {
        margin: 0;
    }
}
.fulfillment-detail-card_title {
    width: 100%;
    max-width: 200px;
}

/* Animasi untuk fadeIn effect */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Peer selector untuk checkbox toggle - untuk browser yang belum support peer */
input[type="checkbox"]:checked + label + div {
  display: block !important;
}

/* Rotasi arrow saat checkbox di-check */
input[type="checkbox"]:checked + label svg {
  transform: rotate(180deg);
}
</style>
